import clsx from 'clsx';
import { toAbsoluteUrl, truncateStringInMiddle } from '../../../../../../_metronic/helpers';
import CopyTextButton from '../../../../../modules/components/copyText/CopyTextButton';
import ToggleSwitch from '../../../../../modules/components/toggleSwitch/ToggleSwitch';

interface Props {
  label: React.ReactNode;
  thumbnail?: string;
  onClickThumbnail?: () => void;
  showThumbnaiPlaceholder?: boolean;
  thumbnailSize?: number;
  isHidden?: boolean;
  onToggle?: () => void;
  showToggle?: boolean;
  className?: {
    thumbnailContainer?: string;
    container?: string;
  };
}

export default function ToggleLabelCard({
  label,
  thumbnail,
  onClickThumbnail,
  showThumbnaiPlaceholder,
  thumbnailSize = 40, //px
  isHidden,
  onToggle,
  showToggle,
  className,
}: Props) {
  return (
    <div
      className={clsx(
        'd-flex gap-2 align-items-start rounded',
        isHidden && 'opacity-50',
        className?.container
      )}
    >
      <div
        className={clsx(
          'd-flex gap-2 align-items-center',
          !showToggle && !thumbnail && !showThumbnaiPlaceholder && 'd-none'
        )}
      >
        {showToggle && (
          <ToggleSwitch
            isVisible={!isHidden}
            onToggle={onToggle}
            size='sm'
            className={{ container: 'flex-shrink-0' }}
          />
        )}

        {/* Thumbnail */}
        {thumbnail && (
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={clsx(className?.thumbnailContainer)}
            style={{
              height: `${thumbnailSize}px`,
              width: `${thumbnailSize}px`,
            }}
          >
            <div className='overlay d-inline-block'>
              <div className='overlay-wrapper'>
                <img
                  src={thumbnail}
                  className='rounded-1'
                  style={{
                    height: `${thumbnailSize}px`,
                    width: `${thumbnailSize}px`,
                    objectFit: 'cover',
                  }}
                  loading='lazy'
                />
              </div>
              <div
                className='overlay-layer bg-dark bg-opacity-50 rounded-1'
                onClick={onClickThumbnail}
                title='View image'
              >
                <i className='fas fa-eye text-white fs-3'></i>
              </div>
            </div>
          </div>
        )}
        {!thumbnail && showThumbnaiPlaceholder && (
          <div
            style={{
              height: `${thumbnailSize}px`,
              width: `${thumbnailSize}px`,
            }}
            className={clsx(
              'rounded-1 bg-gray-200 d-flex align-items-center justify-content-center',
              className?.thumbnailContainer
            )}
          >
            <img
              src={toAbsoluteUrl('/media/icons/duotune/general/gen006.svg')}
              alt='No image'
              loading='lazy'
            />
          </div>
        )}
      </div>

      <span
        className={clsx('text-wrap align-self-center', isHidden && 'text-decoration-line-through')}
      >
        {label}
      </span>
    </div>
  );
}
